<template>
  <BuilderWrapper
    title="Bubbles Legends"
    helpful-tip="You can customize your bubbles' legends here!"
  >
    <LabelledInput>
      <b-checkbox v-model="showLegend">
        Show legend
      </b-checkbox>
    </LabelledInput>

    <template v-if="showLegend">
      <LabelledInput label="Legend position">
        <b-select
          v-model="legendPosition"
          :options="legendPositionOptions"
        />
      </LabelledInput>

      <LabelledInput label="Legend title">
        <b-input v-model="legendTitle" />
      </LabelledInput>

      <template v-if="hollowBubblesDisplayed!==NONE">
        <LabelledInput label="Legend bubble color">
          <ColorPicker v-model="legendBubbleColor" />
        </LabelledInput>

        <LabelledInput label="Solid label">
          <b-input v-model="solidLabel" />
        </LabelledInput>

        <LabelledInput label="Hollow label">
          <b-input v-model="hollowLabel" />
        </LabelledInput>
      </template>
    </template>
  </BuilderWrapper>
</template>

<script lang="ts">

import Vue from 'vue'
import Component from 'vue-class-component'

import BuilderWrapper from '@/components/builder/UI/BuilderWrapper.vue'
import LabelledInput from '@/components/builder/UI/LabelledInput.vue'
import { ColorPicker } from '@orbica/vue-modules'
import { BUBBLES_LEGENDS_CONFIG_KEY, HOLLOW_BUBBLES_CONFIG_KEY } from '@/constants'
import { LegendPositions, HollowBubbleDisplays } from '@/types'

const components = {
  BuilderWrapper,
  LabelledInput,
  ColorPicker,
}

@Component({ components })
export default class BubblesLegendSettings extends Vue {
    NONE = HollowBubbleDisplays.NONE

    legendPositionOptions = [
      { text: 'Top Left', value: LegendPositions.TOP_LEFT },
      { text: 'Bottom Left', value: LegendPositions.BOTTOM_LEFT },
      { text: 'Bottom Right', value: LegendPositions.BOTTOM_RIGHT },
    ]

    get showLegend () {
      return this.$typedStore.primary.app.config[BUBBLES_LEGENDS_CONFIG_KEY].showLegend
    }

    set showLegend (newValue) {
      this.$typedStore.primary.app.updateConfig({
        configPath: [BUBBLES_LEGENDS_CONFIG_KEY, 'showLegend'],
        value: newValue,
      })
    }

    get legendPosition () {
      return this.$typedStore.primary.app.config[BUBBLES_LEGENDS_CONFIG_KEY].legendPosition
    }

    set legendPosition (newValue) {
      this.$typedStore.primary.app.updateConfig({
        configPath: [BUBBLES_LEGENDS_CONFIG_KEY, 'legendPosition'],
        value: newValue,
      })
    }

    get legendTitle () {
      return this.$typedStore.primary.app.config[BUBBLES_LEGENDS_CONFIG_KEY].legendTitle
    }

    set legendTitle (newValue) {
      this.$typedStore.primary.app.updateConfig({
        configPath: [BUBBLES_LEGENDS_CONFIG_KEY, 'legendTitle'],
        value: newValue,
      })
    }

    get hollowBubblesDisplayed () {
      return this.$typedStore.primary.app.config[HOLLOW_BUBBLES_CONFIG_KEY].display
    }

    get legendBubbleColor () {
      return this.$typedStore.primary.app.config[HOLLOW_BUBBLES_CONFIG_KEY].legendBubbleColor
    }

    set legendBubbleColor (newValue) {
      this.$typedStore.primary.app.updateConfig({
        configPath: [HOLLOW_BUBBLES_CONFIG_KEY, 'legendBubbleColor'],
        value: newValue,
      })
    }

    get hollowLabel () {
      return this.$typedStore.primary.app.config[HOLLOW_BUBBLES_CONFIG_KEY].hollowLabel
    }

    set hollowLabel (newValue) {
      this.$typedStore.primary.app.updateConfig({
        configPath: [HOLLOW_BUBBLES_CONFIG_KEY, 'hollowLabel'],
        value: newValue,
      })
    }

    get solidLabel () {
      return this.$typedStore.primary.app.config[HOLLOW_BUBBLES_CONFIG_KEY].solidLabel
    }

    set solidLabel (newValue) {
      this.$typedStore.primary.app.updateConfig({
        configPath: [HOLLOW_BUBBLES_CONFIG_KEY, 'solidLabel'],
        value: newValue,
      })
    }
}

</script>
